import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Link, useNavigate} from "react-router-dom";
import ModalCreateOrUpdateMaterialStripe from "./ModalCreateOrUpdateMaterialStripe";
import CellCheckboxAMPUTFixPrice from "../arrival/CellCheckboxAMPUTFixPrice";
import CellPriceWithCurrency from "../../../../сell/CellPriceWithCurrency";
import FilterUtil from "../../../../../../utils/common/FilterUtil";
import CellCheckbox from "../../../../сheckbox/CellCheckbox";
import SupplierMaterialUtil from "../../../../../../utils/warehouse/SupplierMaterialUtil";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import ButtonCreate from "../../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import ButtonBack from "../../../../button/ButtonBack";

const MaterialStripeTable = ({
                                 id,
                                 materialId,
                                 data,
                                 setData,
                                 supplierList,
                                 isArchive,
                                 urlArchive,
                                 baseUnit,
                                 typeMaterial,
                                 setSupplierId,
                                 setCurrencyId,
                                 price,
                                 setPrice,
                                 supplierId,
                                 currencyId,
                                 isMin,
                                 allPrice,
                                 create,
                                 update,
                                 addArchive,
                                 isAll,
                                 currencyMap,
                                 tableOptions,
                                 tableOptionsHandle,
                                 handleModalAlert,
                                 isAdmin,
                                 isFixPrice,
                                 readOnly
                             }) => {

    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [createOrUpdateModalOpen, setCreateOrUpdateModalOpen] = useState(false);
    const [isNew, setIsNew] = useState(null);

    const navigate = useNavigate();

    const redirectArchive = () => {
        navigate(urlArchive + '/' + id + '/' + baseUnit + '/' + typeMaterial + '/' + materialId);
    };

    const redirectMaterial = () => {
        navigate(isAll ? '/all-materials/' + materialId + '/' + baseUnit + '/' + typeMaterial : '/organization/materials/' + id + '/' + baseUnit + '/' + typeMaterial + '/' + materialId);
    };
    const [loading, setLoading] = useState(false)
    const handleAddStripe = () => {

        const basePrice = {
            id: null, currency: currencyMap.get(1), price: "",
        };

        setIsNew(true);

        const stripe = {
            id: null,
            supplier: null,
            basePrice: basePrice,
            fixPrice: false,
            length: 2800,
            width: 0,
            trimmingLeft: 20,
            trimmingRight: 20,
            trimmingTop: 20,
            trimmingBottom: 20,
            typeSupplierMaterial: isMin ? "BY_MIN_STRIPE" : "BY_FIXED_STRIPE",
        };

        setCurrentEditRowData(stripe);
        setCreateOrUpdateModalOpen(true);
    };

    const handleCloseCreateOrUpdate = () => {

        setCurrentEditRowData(null);
        setIsNew(null);
        setSupplierId(null);
        setCurrencyId(null);
        setPrice(null);
        setCreateOrUpdateModalOpen(false);
    };

    const handleSubmitCreateStripe = () => {
        setLoading(true)
        const currentSupplierId = supplierId === null ? supplierList[0].id : supplierId;
        const currentCurrencyId = currencyId === null ? currencyMap.get(1).id : currencyId;

        create(currentEditRowData, id, currentSupplierId, currentCurrencyId, price).then(function (response) {
            let data = response.data;
            handleCreateNewRow(data)
            handleCloseCreateOrUpdate();
            handleModalAlert("Данные добавлены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setLoading(false))
    }

    const handleCreateNewRow = (values) => {
        if (isMin) {
            SupplierMaterialUtil.deleteSupplierId(data, supplierId === null ? supplierList[0].id : supplierId);
            setData(data);
        } else {
            SupplierMaterialUtil.deleteSupplierIdWithWeightAndHeight(data,
                supplierId === null ? supplierList[0].id : supplierId,
                values.length, values.width);
        }

        data.push(values);
        setData([...data]);
    };

    const handleUpdateStripe = useCallback((row) => {
        setCurrentEditRowData(row);
        setCreateOrUpdateModalOpen(true);
        setIsNew(false);
    }, [data, currentEditRowData, setCurrentEditRowData]);

    const handleSubmitUpdateStripe = () => {
        setLoading(true)
        update(currentEditRowData).then(function (response) {
            let data = response.data;
            setData(prev => prev.map(el => el.id === data.id ? data : el));
            handleCloseCreateOrUpdate();
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setLoading(false))
    }

    const sendToArchive = useCallback((row) => {
        addArchive(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id));
                handleModalAlert("Доавлено в архив", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }, [data]);

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Поставщик',
                accessorFn: (row) => row.supplier?.name,
                minSize: 150,
                Cell: ({cell, row}) => (<li key={cell.getValue()}>
                    <Link
                        to={'/organization/suppliers/' + data[row.index].supplier?.id}>{cell.getValue()}</Link>
                </li>),
            },
            {
                header: 'Артикул поставщика',
                accessorKey: 'article',
                minSize: 150,
            },
            {
                header: 'Найменование поставщика',
                accessorKey: 'materialNameSupplier',
                minSize: 250,
            },
            {
                id: 'length', header: 'Ширина', accessorKey: 'length', minSize: 15, maxSize: 15,
            },
            {
                id: 'width', header: 'Высота', accessorKey: 'width', minSize: 15, maxSize: 15,
            },
            {
                id: 'trimming',
                header: 'Отступы',
                accessorFn: (row) => row.materialPriceUnit?.trimmingLeft,
                minSize: 10,
                maxSize: 10,
                Cell: ({row}) => '['
                    + row.original.trimmingLeft + ', '
                    + row.original.trimmingRight + ', '
                    + row.original.trimmingTop + ', '
                    + row.original.trimmingBottom + ']',
            },
            {
                id: 'basePrice',
                header: 'Баз. цена',
                accessorFn: (row) => row.materialPriceUnit?.trimmingLeft,
                size: 8, Cell: ({row}) => {
                    const basePrice = row.original.basePrice || null;
                    return basePrice === null ? '' : (<CellCheckboxAMPUTFixPrice
                        price={basePrice}
                        fixPrice={row.original.fixPrice}
                        currencyMap={currencyMap}
                    />);
                }, minSize: 8, maxSize: 8,
            },
            {
                id: 'basePrice.dateTime',
                header: 'Дата',
                accessorFn: (row) => row.basePrice?.dateTime,
                minSize: 10,
                maxSize: 10,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? '' : DateTimeUtil.dateTimeToString(value);
                },
                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter column={column}/>,
            },
        ];

        if (isArchive && !isAdmin) {
            baseColumns.splice(0, 0, {
                id: 'current',
                header: 'Текущий',
                accessorKey: 'current',
                size: 8,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: FilterUtil.statusList,
                filterFn: (row, id, filterValue) => {
                    return FilterUtil.checkStatus(row.getValue(id), filterValue)
                },
                Cell: ({cell}) => <CellCheckbox
                    cell={cell}
                    disabled={true}
                />,
            });
        }

        if (allPrice && !isAdmin) {
            baseColumns.splice(7, 0, {
                id: 'lastRealPrice',
                header: 'Посл. реальная цена',
                accessorFn: (row) => row.lastRealPrice?.price,
                size: 8,
                Cell: ({row}) => {
                    const lastRealPrice = row.original.lastRealPrice
                    return lastRealPrice && (
                        <span>{lastRealPrice?.price?.toFixed(3)} {currencyMap.get(lastRealPrice.currencyId).curAbbreviation}</span>)
                },
                minSize: 10,
                maxSize: 10,
            });
        }

        if (allPrice && !isAdmin) {
            baseColumns.splice(8, 0, {
                id: 'averageRealPrice',
                header: 'Ср. реальная цена',
                accessorFn: (row) => row.averageRealPrice?.price,
                size: 8,
                Cell: ({row}) => {
                    const averageRealPrice = row.original.averageRealPrice
                    return averageRealPrice && (
                        <span>{averageRealPrice?.price?.toFixed(3)} {currencyMap.get(averageRealPrice.currencyId).curAbbreviation}</span>)
                },
                minSize: 10,
                maxSize: 10,
            });
        }

        if (allPrice && !isAdmin) {
            baseColumns.splice(9, 0, {
                id: 'maxRealPrice',
                header: 'Макс. реальная цена',
                accessorFn: (row) => row.maxRealPrice?.price,
                size: 8,
                Cell: ({row}) => {
                    const maxRealPrice = row.original.maxRealPrice
                    return maxRealPrice && (
                        <span>{maxRealPrice?.price?.toFixed(3)} {currencyMap.get(maxRealPrice.currencyId).curAbbreviation}</span>)
                },
                minSize: 10,
                maxSize: 10,
            });
        }

        return baseColumns;

    }, [data, isArchive, currencyMap]);

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleUpdateStripe},
        {type: "archive", text: "В архив", handler: sendToArchive}
    ]
    return (<div>
        <Box
            sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px", gap: "10px"}}
        >
            {!isArchive && !readOnly && <ButtonCreate
                text={"Добавить полосу поставщика"}
                width={300}
                onClick={handleAddStripe}
            />}
            {!isArchive && <ButtonCreate
                text={"Архив цен"}
                width={100}
                icon={false}
                onClick={redirectArchive}
            />}
            {isArchive && <ButtonBack
                text={"Вернуться к материалу"}
                width={230}
                onClick={redirectMaterial}
            />}
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            selectAllMode={"all"}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": !isArchive && !readOnly && {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data || []}
            rowHeight={13}
            columnSpacing={1}
            initialState={{
                columnVisibility: {
                    id: false,
                }, isFullScreen: false, density: "compact", pagination: {pageIndex: 0, pageSize: 100},
            }}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            state={{showGlobalFilter: true, pagination: tableOptions,}}
            rowCount={tableOptions.totalElements}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={!isArchive && !readOnly}
            enableToolbarInternalActions={false}
            getRowId={(originalRow) => originalRow.id}
        />
        {createOrUpdateModalOpen && <ModalCreateOrUpdateMaterialStripe
            open={createOrUpdateModalOpen}
            onClose={handleCloseCreateOrUpdate}
            title={isNew ? 'Добавить базовую цену поставщика' : 'Редактировать базовую цену поставщика'}
            values={currentEditRowData}
            setValues={setCurrentEditRowData}
            labelButtonSSubmit={isNew ? 'Добавить' : 'Обновить'}
            handleSubmit={isNew ? handleSubmitCreateStripe : handleSubmitUpdateStripe}
            supplierList={supplierList}
            setSupplierId={setSupplierId}
            currencyMap={currencyMap}
            setCurrencyId={setCurrencyId}
            price={price}
            setPrice={setPrice}
            isNew={isNew}
            allPrice={allPrice}
            isAdmin={isAdmin}
            isFixPrice={isFixPrice}
            loading={loading}
        />}
    </div>);
};
export default MaterialStripeTable;